import { render, staticRenderFns } from "./SyncFacebookPageComponent.vue?vue&type=template&id=518d7f72&"
import script from "./SyncFacebookPageComponent.vue?vue&type=script&lang=ts&"
export * from "./SyncFacebookPageComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports